import { render } from "./AdDocViewInvitationsOpenAddPopupButton.vue?vue&type=template&id=ebcd60be&ts=true"
import script from "./AdDocViewInvitationsOpenAddPopupButton.vue?vue&type=script&lang=ts"
export * from "./AdDocViewInvitationsOpenAddPopupButton.vue?vue&type=script&lang=ts"

import "./AdDocViewInvitationsOpenAddPopupButton.vue?vue&type=style&index=0&id=ebcd60be&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__